<template>
  <div id="app">
    <div class="home">
      <Home v-if="viewByName == 'Home'"></Home>
      <question v-else-if="viewByName == 'question'"></question>
    </div>
  </div>
</template>

<script>
import Home from '@/views/home/index.vue';
import question from "@/views/question/question.vue";

export default {
  name: 'App',
  components: {
    Home, question
  },
  data() {
    return {
      viewByName: "Home"
    }
  },
  created() {
    let search = window.location.search;
    let searchParams = {};
    if (search) {
      let searchList = search.replace("?", "").split("&");
      searchList.forEach(param => {
        let [key, value] = param.split("=");
        searchParams[key] = decodeURIComponent(value);
      });
    }
    this.viewByName = searchParams["viewName"] ? searchParams["viewName"] : "Home";
    if (this.viewByName == "question") {
      window.document.title = "汇友驿站交易技术峰会现场互动";
    }
  },
  mounted() {
    
  },
  methods: {}
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body { margin: 0; padding: 0; overflow-x: hidden; overflow-y: auto; }
@import url(./assets/iconfont/iconfont.css);
</style>
